<template>
	<div class="ml-45 mr-44">
	<div class="flex j-between  pb-26 a-center" style="border-bottom: 1px solid #E1E1E1; box-sizing: border-box;">
		<div class="tit-24 ys-33 B-400 userProfile-righttitle montserRegular">
			<!-- My points -->
			{{gudingziduan.PointsMall.mypoints}}
		</div>
	<!-- 	<el-date-picker  class="cur_pointer pointsinput" :append-to-body="false" v-model="postdate"
			type="month" prefix-icon="el-icon-time" placeholder="Date" @change="xuanshijian"></el-date-picker> -->
			<el-date-picker  class="cur_pointer pointsinput2" @change="xuanshijian"  v-model="postdate"  type="daterange" range-separator="to"  start-placeholder="Start Date"  end-placeholder="End Date">  </el-date-picker>
	</div>
	<div class="userreplies-right-contrn pt-35">
		 <el-table  :data="pointsData" class="userpointsdata"   style="width: 100%">
			<el-table-column prop="Date" label="DATE" min-width="100" max-width="200">
				<template slot-scope="shu">
					{{shu.row.createTime}}
				</template>
			</el-table-column>
			<el-table-column prop=""  label="ACTION"  min-width="200"> 
				<template slot-scope="shu">
					<div class="tit-12 pt-6" style="color: #9A9A9A;">
						<span v-if="shu.row.detail">{{shu.row.detail}}</span>
						<span v-else>{{shu.row.event}}{{shu.row.remark}}</span>
						
						<!-- <el-divider v-if="shu.row.detail && shu.row.title" direction="vertical"></el-divider>
						<span>title:{{shu.row.title}}</span> -->
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="points"  label="POINTS" > 
				<template slot-scope="shu">
					<span :class="Number(shu.row.ponitTotal) > 0 ? 'zihong' : 'zilv' ">{{shu.row.ponitTotal}}</span>
				</template>
			</el-table-column>
			
		 </el-table>
		<el-pagination class="flex j-center pb-108 pt-60"  @current-change="handleCurrentChange"
			:current-page.sync="so.page" :page-size="so.jitiao" layout="prev, pager, next, jumper,slot" :total="zongshu">
			<span class="ml-10 cur_pointer" @click="goToPage">go</span>
		</el-pagination>
	</div>
	</div>
</template>

<script>
	import {mypoints} from '@/api/Personal.js';
	export default {
	  data() {  
	    return {  
	    pointsData:[
	   //  	{name:'Alek',title:'Gw5000-DNS-30 what set up to get battery',group:'Install Equipment',Date:'2023.06.07',points:'-300'},
	   //  	{name:'Alek',title:'Gw5000-DNS-30 what set up to get battery',group:'Subscribe to a group',Date:'2023.06.07',points:'300'},
	   //  	{name:'Alek',title:'Gw5000-DNS-30 what set up to get battery',group:'Reward',Date:'2023.06.07',points:'300'},
	   //  	{name:'Alek',title:'Gw5000-DNS-30 what set up to get battery',group:'Get points',Date:'2023.06.07',points:'300'},
	   //  	{name:'Alek',title:'Gw5000-DNS-30 what set up to get battery',group:'Get points',Date:'2023.06.07',points:'300'},
	   //  	{name:'Alek',title:'Gw5000-DNS-30 what set up to get battery',group:'Get points',Date:'2023.06.07',points:'-400'},
	   //  	{name:'Alek',title:'Gw5000-DNS-30 what set up to get battery',group:'Get points',Date:'2023.06.07',points:'300'},
	   //  	{name:'Alek',title:'Gw5000-DNS-30 what set up to get battery',group:'Get points',Date:'2023.06.07',points:'300'},
	   //  	{name:'Alek',title:'Gw5000-DNS-30 what set up to get battery',group:'Get points',Date:'2023.06.07',points:'300'}
	   
		],
	    so:{page:1,jitiao:10,jieshu:'',kaishi:''},
	    zongshu:0,
		gudingziduan:{},
	    postdate:''
	    };  
	  },  
	  props: {
	  	usersshu: {
	  		type: [Object,Array],
	  		default() {
	  				return { /* 默认对象或数组的内容 */ };
	  			  }
	  	},
	  },
	  watch: {
	      '$store.state.cunyuanyan': {
	        handler(newValue, oldValue) {
	          // console.log('语言已更新:', newValue);
	          this.gudingziduan=this.$store.state.cunyuanyan
	  		// console.log(this.gudingziduan,'video')
	        },
	        deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
	      }
	  },
	  created() {
		  this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
		  this.gudingziduan=this.$store.state.cunyuanyan
		  this.jifenlie()
	  },
	  methods: {  
		jifenlie(){
			mypoints({pageNum:this.so.page-1,pageSize:this.so.jitiao,endTime:this.so.jieshu,startTime:this.so.kaishi,type:''}).then(shu=>{
				this.pointsData=shu.data.content
				this.zongshu=Number(shu.data.totalElements)
			
			})
		},
		xuanshijian(e){
			console.log(e)
			this.so.kaishi=e[0]
			this.so.jieshu=e[1]
			this.jifenlie()
		},
		handleCurrentChange(){
			this.jifenlie()
		},
		goToPage(){
			this.handleCurrentChange(this.sos.ye)
		}
	  }  
	}; 
</script>
<style lang="scss" scoped>
	::v-deep .pointsinput{
		width:2.1rem;
		height:.50rem;
		min-width: 180px;
		min-height: 35px;
	}
	
	.pointsinput2 {
		background: #F6F6F8;
		border-radius: 100px;
		border:none;
	}
	::v-deep .pointsinput2 .el-range-input{
		background:no-repeat;
	}
	::v-deep .pointsinput .el-input__inner {
		border-radius: 100px;
		padding-left: 48px;
		background: #F6F6F8;
		border: none;
		height: 100%;
		
	}
	::v-deep .pointsinput .el-input__prefix {
		left: 15px;
	}
	
	::v-deep .pointsinput .el-input__icon {
		font-size: var(--font20);
		color: #6b6b6b;
		display: flex;
		align-items: center;
	}
	
	// 时间组件样式
	::v-deep .el-month-table td.today .cell {color: #E60012;}
</style>
<style lang="scss" scoped>
	.userProfile-right{
		width:77%;
		min-height: 7.2rem;
		.userProfile-right-btn{
			display: inline-block;
			padding: .17rem .52rem .19rem .53rem;
			border-radius: 26px;
			border: 1px solid #e50012;
			box-sizing: border-box;
		}
	}
	.zihong{
		color:#E71018;
	}
	.zilv{
		color:#008C59;
	}
	.userpointsdata .has-gutter th{
		background: #F6F6F8;
		color: #333333;
		padding: .21rem 0;
	}
	.userpointsdata .el-table_1_column_1 .cell{
		padding-left: .5rem;
	}
</style>